import { ReactRouterAppProvider } from "@toolpad/core/react-router";
import { useNavigate, useSearchParams } from "react-router";
import { NAVIGATION } from "../navigation";
import logo from "../assets/logo.png";
// import { SyncStatusDashboard } from "./components/SyncStatusDashboard";
import { Router } from "@toolpad/core";
import { useMemo } from "react";
import { useFilters } from "../providers/FiltersProvider";

export function RouterAppProvider({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const filters = useFilters();

  const router = useMemo<Router>(() => {
    return {
      pathname: "/",
      searchParams,
      navigate: (to) => {
        navigate(`${to}?${searchParams.toString()}`, {
          state: {
            activeFilters: filters.active,
          },
        });
      },
    };
  }, [searchParams, filters.active]);

  return (
    <ReactRouterAppProvider
      navigation={NAVIGATION}
      branding={{
        logo: <img src={logo} alt="Logo" />,
        title:
          "Garipalli Analytics" +
          (import.meta.env.VITE_ENV ? ` [${import.meta.env.VITE_ENV}]` : ""),
      }}
      router={router}
    >
      {children}
    </ReactRouterAppProvider>
  );
}
